function initPopupsClearDN() {
	if (document.querySelectorAll('.gui-page__block-element') != null) {
		const blockElements = document.querySelectorAll('.gui-page__block-element')
		if(!blockElements) return 
		let popup = ''
		blockElements.forEach((item) => {
			popup = item.querySelector('[style]')
			if (popup) {
				popup.removeAttribute('style')
			}
		})
	}
}
